import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"rgba(0, 32, 73, 0.4)"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 고령자의  ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-white font-weight-black" }, "뇌건강 관리", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("를 위한 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 뇌건강 테스트와 뇌기능별 훈련 프로그램 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 뇌건강 테스트와 케어까지 한 번에 스마트폰으로 손쉽게 이용하실 수 있는 헬스케어 서비스 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 서비스 소개 다운로드 ")

import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, smAndDown, smAndUp, mdAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([{
      backgroundImage:
        'url(' + require('../../assets/main/main_cover.webp') + ')',
    }, {"background-size":"cover","background-position":"center left","z-index":"1"}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: _normalizeClass(["elevation-0", { 'my-10': _unref(xs) }]),
            style: {"margin":"4rem auto","background-color":"transparent"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, {
                class: _normalizeClass(["font-weight-medium text-grey-lighten-4", { 'text-h5 pb-0': _unref(xs), 'text-h4': _unref(sm), 'text-h3': _unref(mdAndUp) }]),
                style: {"line-height":"0.8"}
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_card_title, {
                class: _normalizeClass(["font-weight-medium text-grey-lighten-4", { 'text-h5': _unref(xs), 'text-h4': _unref(sm), 'text-h3': _unref(mdAndUp) }]),
                style: {"line-height":"1.5","word-break":"keep-all"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_spacer, {
                class: _normalizeClass({ 'py-1': _unref(xs), 'py-4': _unref(smAndUp) })
              }, null, 8, ["class"]),
              _createVNode(_component_v_card_text, {
                class: _normalizeClass(["text-white", {
              'text-subtitle-2': _unref(smAndDown),
              'text-subtitle-1': _unref(mdAndUp),
            }]),
                style: {"word-break":"keep-all"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_spacer, {
                class: _normalizeClass({ 'py-2': _unref(xs), 'py-6': _unref(smAndUp) })
              }, null, 8, ["class"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["text-white ml-4", {
              'text-subtitle-2 pa-5': _unref(smAndDown),
              'text-subtitle-1 pa-6': _unref(mdAndUp),
            }]),
                variant: "outlined",
                rounded: "pill",
                href: "/files/(주)하이 서비스소개서.zip",
                download: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})